const R = 'ROOM:';
export const SocketEvents = {
  showMessages: R + 'SHOW_MESSAGE',
  newMessages: R + 'NEW_MESSAGE',
  likedMessages: R + 'LIKED_MESSAGE',
  editMessage: R + 'EDIT_MESSAGE',
  showChat: R + 'ChatShow',
  join: R + 'JOIN',
  leave: R + 'LEAVE',
  deleteM: R + 'DELETE_MESSAGE',
  likeM: R + 'LIKE_MESSAGE',
  pinM: R + 'PIN_MESSAGE',
  markM: R + 'MARK_MESSAGE',
  respM: R + 'RESPONSE_MESSAGE',
  answerM: R + 'ANSWER_MESSAGE',
  countU: R + 'COUNT_USERS',
  startTest: R + 'TestStart',
  startVote: R + 'VoteStart',
  endVote: R + 'VoteEnd',
  startVotesGroup: R + 'StartVotesGroup',
  endVotesGroup: R + 'EndVotesGroup',

  startVotesRatingGroup: R + 'StartVotesRatingGroup',
  endVotesRatingGroup: R + 'EndVotesRatingGroup',
  startVoteRating: R + 'VoteRatingStart',
  endVoteRating: R + 'VoteRatingEnd',
  showVoteRating: R + 'VoteRatingShow',
  votesRating: R + 'ShowUsersVotesRating',

  showLink: R + 'LinkShow',
  showVideo: R + 'VideoShow',
  hideVideo: R + 'VideoHide',
  showTest: R + 'TestShow',
  showVote: R + 'VoteShow',
  callToActionStart: R + 'CallToActionStart',
  callToActionEnd: R + 'CallToActionEnd',
  callToActionClick: R + 'CallToActionClick',
  callToActionReset: R + 'CallToActionReset',

  createdPChat: R + 'CREATED_PRIVATE_CHAT',
  newPMess: R + 'NEW_PRIVATE_MESSAGE',
};

export const ApiEvents = {
  getTechnicalTexts: '/api/events/technical-texts',
  showInteractive: '/api/events/show_interactive',
  defaultLink: '/api/links/default_link',
  readyTest: '/api/test/ready_test',
  passedTest: '/api/test/passed_test',
  readyVote: '/api/vote/ready_vote',
  readyVoteGroup: '/api/vote/ready_vote_group',
  passedVote: '/api/vote/passed_vote',
  passedVoteGroup: '/api/vote/passed_vote_group',
  readyVoteRating: '/api/vote_rating/ready_vote',
  passedVoteRating: '/api/vote_rating/passed_vote',
  passedVoteRatingGroup: '/api/vote_rating/passed_vote_group',
  readyVoteRatingGroup: '/api/vote_rating/ready_vote_group',
  checks: '/api/checks',
  showUsers: '/api/events/show_users',
  events: '/api/events',
  getMessages: '/api/chat/messages',
  showMessages: '/api/chat/show_chat',
  newM: '/api/chat/new_message',
  deleteM: '/api/chat/delete_message',
  likeM: '/api/chat/like_message',
  pinM: '/api/chat/pin_message',
  markM: '/api/chat/mark_question',
  respM: '/api/chat/response_question',
  answerM: '/api/chat/answer_message',
  finalTest: '/api/test/final_test',
  sendFinalTest: '/api/test/ready_final_test',
  clickCallToAction: '/api/call/click_call_action',
  callToAction: '/api/call/call_action',

  getPChats: '/api/private_chat/chats',
  sendPMessage: '/api/private_chat/new_message',
  openPChat: '/api/private_chat/open_chat',
  closePChat: '/api/private_chat/close_chat',

  getTicket: '/api/tickets/ticket',
};
